import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "clearfix"
}
const _hoisted_2 = {
  key: 1,
  class: "card mb-25 border-0 rounded-0 bg-white letter-spacing"
}
const _hoisted_3 = { class: "card-head box-shadow bg-white d-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25 gap-10" }
const _hoisted_4 = {
  class: "position-relative",
  style: {"min-width":"220px","max-width":"300px","flex":"1 1 auto"}
}
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = {
  key: 1,
  class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0",
  type: "button",
  "data-bs-toggle": "modal",
  "data-bs-target": "#companyModalBulk",
  style: {"background-color":"#6560F0"}
}
const _hoisted_7 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_8 = { class: "table-responsive" }
const _hoisted_9 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_10 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
}
const _hoisted_11 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
}
const _hoisted_12 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
}
const _hoisted_13 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
}
const _hoisted_14 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
}
const _hoisted_15 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_16 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_17 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_18 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_19 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_20 = {
  key: 0,
  class: "shadow-none lh-1 fw-medium text-black-emphasis"
}
const _hoisted_21 = {
  key: 1,
  class: "shadow-none lh-1 fw-medium text-black-emphasis"
}
const _hoisted_22 = {
  key: 2,
  class: "shadow-none lh-1 fw-medium text-black-emphasis"
}
const _hoisted_23 = {
  key: 3,
  class: "shadow-none lh-1 fw-medium text-black-emphasis"
}
const _hoisted_24 = {
  key: 4,
  class: "shadow-none lh-1 fw-medium text-black-emphasis"
}
const _hoisted_25 = {
  key: 5,
  class: "shadow-none lh-1 fw-medium text-black-emphasis"
}
const _hoisted_26 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_27 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_28 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_29 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_30 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_31 = {
  key: 0,
  class: "badge text-outline-success"
}
const _hoisted_32 = {
  key: 1,
  class: "badge text-outline-danger"
}
const _hoisted_33 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }
const _hoisted_34 = { class: "dropdown" }
const _hoisted_35 = { class: "dropdown-menu" }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { key: 1 }
const _hoisted_39 = {
  key: 0,
  class: "pagination-area d-md-flex mt-15 mt-md-25 mb-0 justify-content-between align-items-center"
}
const _hoisted_40 = {
  key: 0,
  class: "mb-0 text-paragraph"
}
const _hoisted_41 = { class: "fw-bold" }
const _hoisted_42 = { class: "fw-bold" }
const _hoisted_43 = {
  key: 1,
  class: "mb-0 text-paragraph"
}
const _hoisted_44 = { class: "fw-bold" }
const _hoisted_45 = { class: "fw-bold" }
const _hoisted_46 = { class: "mt-15 mt-md-0" }
const _hoisted_47 = { class: "pagination mb-0" }
const _hoisted_48 = {
  key: 0,
  class: "page-item"
}
const _hoisted_49 = {
  key: 0,
  class: "page-link active",
  href: "#"
}
const _hoisted_50 = ["onClick"]
const _hoisted_51 = {
  key: 1,
  class: "page-item"
}
const _hoisted_52 = {
  class: "modal fade",
  id: "companyModalBulk",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_53 = { class: "modal-dialog modal-lg modal-dialog-centered" }
const _hoisted_54 = { class: "modal-content" }
const _hoisted_55 = { class: "modal-header" }
const _hoisted_56 = { class: "modal-title fs-5" }
const _hoisted_57 = { class: "modal-body" }
const _hoisted_58 = {
  key: 0,
  style: {"margin-top":"5%"}
}
const _hoisted_59 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_60 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_61 = {
  key: 1,
  style: {"margin-top":"5%"}
}
const _hoisted_62 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"green"}
}
const _hoisted_63 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_64 = { class: "col-md-6" }
const _hoisted_65 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_66 = { value: "" }
const _hoisted_67 = ["value"]
const _hoisted_68 = { class: "col-md-6" }
const _hoisted_69 = { class: "form-label" }
const _hoisted_70 = ["onUpdate:modelValue"]
const _hoisted_71 = { class: "col-md-6" }
const _hoisted_72 = { class: "form-label" }
const _hoisted_73 = ["onUpdate:modelValue"]
const _hoisted_74 = { class: "invalid-feedback" }
const _hoisted_75 = { class: "modal-footer" }
const _hoisted_76 = {
  key: 0,
  type: "submit",
  class: "btn text-white",
  style: {"background-color":"#EB9355"}
}
const _hoisted_77 = {
  class: "modal fade",
  id: "companyModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_78 = { class: "modal-dialog modal-lg modal-dialog-centered" }
const _hoisted_79 = { class: "modal-content" }
const _hoisted_80 = { class: "modal-header" }
const _hoisted_81 = { class: "modal-title fs-5" }
const _hoisted_82 = { class: "modal-body" }
const _hoisted_83 = {
  key: 0,
  style: {"margin-top":"5%"}
}
const _hoisted_84 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_85 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_86 = {
  key: 1,
  style: {"margin-top":"5%"}
}
const _hoisted_87 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"green"}
}
const _hoisted_88 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_89 = { class: "row" }
const _hoisted_90 = { class: "col-md-6" }
const _hoisted_91 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_92 = ["placeholder"]
const _hoisted_93 = { class: "invalid-feedback" }
const _hoisted_94 = { class: "col-md-6" }
const _hoisted_95 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_96 = ["placeholder"]
const _hoisted_97 = { class: "invalid-feedback" }
const _hoisted_98 = { class: "row" }
const _hoisted_99 = { class: "col-md-6" }
const _hoisted_100 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_101 = ["selected"]
const _hoisted_102 = ["selected"]
const _hoisted_103 = ["selected"]
const _hoisted_104 = { class: "col-md-6" }
const _hoisted_105 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_106 = ["selected"]
const _hoisted_107 = ["selected"]
const _hoisted_108 = ["selected"]
const _hoisted_109 = ["selected"]
const _hoisted_110 = ["selected"]
const _hoisted_111 = ["selected"]
const _hoisted_112 = ["selected"]
const _hoisted_113 = ["selected"]
const _hoisted_114 = { class: "row" }
const _hoisted_115 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_116 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_117 = { value: "" }
const _hoisted_118 = ["value"]
const _hoisted_119 = { class: "col-md-6" }
const _hoisted_120 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_121 = { value: "" }
const _hoisted_122 = ["value", "selected"]
const _hoisted_123 = {
  key: 0,
  class: "row"
}
const _hoisted_124 = { class: "col-md-6" }
const _hoisted_125 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_126 = { value: "" }
const _hoisted_127 = ["value", "selected"]
const _hoisted_128 = { class: "modal-footer" }
const _hoisted_129 = {
  key: 0,
  type: "submit",
  class: "btn text-white",
  style: {"background-color":"#EB9355"}
}

import { ref, onMounted, reactive, inject } from "vue";
import axios from 'axios';
import router from '../../router/index'
import { showToast, checkSessionValidate } from "../../utils/function";
import { useTableFilter } from "../../utils/UseTablefilter";
import { current_permissions } from '../../utils/permission';
import { useRoute, useRouter } from 'vue-router'
import * as yup from 'yup';
import { Country, Fee, Operator, Organization, TypeFree } from "@/utils/Model";


export default /*@__PURE__*/_defineComponent({
  __name: 'FeeContent',
  setup(__props) {

const backApi = inject('back');
let edit = 0;
let itemCode = '';
let code: string | null = '';
const selectedOrganization = ref('');
const selectedOperator = ref('');
const selectedCountry = ref('');
const selectedTypeFee = ref('');
const selectedMode = ref('');

const loader = ref(false);
let token: string | null = localStorage.getItem('login_token');

const countries = ref(new Array<Country>());
const fees = ref(new Array<Fee>());
const organizations = ref(new Array<Organization>());
const operators = ref(new Array<Operator>());
const typefees = ref(new Array<TypeFree>());
let operatorsTemp = new Array<Operator>();
let countriesTemp = new Array<Country>();

const errors = ref('');
const errorId = ref('');
const success = ref('');
const errorIdBulk = ref('');
const errorsBulk = ref('');
const successBulk = ref('');

const errorsBis: any = { 'name': '', 'valeur': '' };
const pageLoad = ref(false);

const formValues = reactive({
  valeur: "",
  name: ""
});

const {
  searchQuery,
  paginatedData: paginatedFees,
  filteredTotal,
  page,
  numPages,
  pageSize,
  showingFrom,
  showingTo,
  goToPage,
} = useTableFilter(
  fees,
  [
    (f: any) => f.code,
    (f: any) => f.organization?.name,
    (f: any) => f.country?.name,
    (f: any) => f.operator?.mnoName,
    (f: any) => f.name,
    (f: any) => f.value,
    (f: any) => f.mode,
    (f: any) => f.typeFee?.name,
    (f: any) => f.status,
  ],
  15
);

const schema = yup.object({
  valeur: yup.number().required('La valeur est requise'),
  name: yup.string().required('Le nom du frais est requis'),
});

const feeList = ref([
  { name: "I-MONEY", valeur: 0 },
  { name: "I-MONEY PAYOUT", valeur: 0 },
  { name: "BANK_REPAYMENT", valeur: 0 },
  { name: "CRYPTO_REPAYMENT", valeur: 0 },
  { name: "TOPUP", valeur: 0 },
]);

const initField = () => {
  formValues.name = '';
  formValues.valeur = "";
  selectedOrganization.value = code || '';
  selectedOperator.value = '';
  selectedTypeFee.value = '';
  selectedMode.value = '';
  selectedCountry.value = '';
  itemCode = '';
  edit = 0;
  errorId.value = '';
  errors.value = '';
}

function handleOrganizationChange(event) {
  selectedOrganization.value = event.target.value;
}

function handleOperatorChange(event) {
  selectedOperator.value = event.target.value;
}

function handleTypeFeeChange(event) {
  selectedTypeFee.value = event.target.value;
}

function handleModeChange(event) {
  selectedMode.value = event.target.value;
}

function handleCountryChange(event) {
  var i = 0;
  while (i < countriesTemp.length) {
    if (countriesTemp[i].countryCode == event.target.value) {
      selectedCountry.value = countriesTemp[i].code;
    }
    i++;
  }
  var j = 0;
  var operatorArr = new Array<Operator>();
  while (j < operatorsTemp.length) {
    if (operatorsTemp[j].countryCode == event.target.value) {
      operatorArr.push(operatorsTemp[j]);
    }
    j++;
  }
  operators.value = operatorArr;
}

function formatDateFr(value) {
  if (value) {
    const year = value.getFullYear();
    let month = value.getMonth() + 1;
    month = month < 10 ? '0' + month : month;
    let day = value.getDate();
    day = day < 10 ? '0' + day : day;
    return day + '/' + month + '/' + year;
  }
}

// Récupère une page de frais depuis l'API (forme { data, pagination })
const fetchFeesPage = (targetPage: number) => {
  return axios.get(backApi + '/secure/fees/?organization=' + (code || '') + '&currentPage=' + targetPage, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
}

const getFees = async () => {
  try {
    const first = await fetchFeesPage(1);
    const collected: any[] = [...first.data.data];
    const totalPages = parseInt(first.data.pagination?.numPages ?? 1);

    if (totalPages > 1) {
      const remainingRequests = [];
      for (let p = 2; p <= totalPages; p++) {
        remainingRequests.push(fetchFeesPage(p));
      }
      const results = await Promise.all(remainingRequests);
      results.forEach(r => collected.push(...r.data.data));
    }

    fees.value = collected;
  } catch (error: any) {
    if (error.response) {
      if (error.response.status === 401) {
        router.push('/')
      }
    }
  }
}

const getOrganizations = () => {
  axios.get(backApi + '/secure/organizations/', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then((response) => {
      organizations.value = response.data.data ?? response.data;
      console.log(response.data);
    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        }
      }
    });
}

const getTypeFees = () => {
  axios.get(backApi + '/secure/typefees/', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then((response) => {
      typefees.value = response.data.data ?? response.data;
    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        }
      }
    });
}

const getCountries = () => {
  axios.get(backApi + '/secure/countries/', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then((response) => {
      const list = response.data.data ?? response.data;
      countriesTemp = list;
      countries.value = list;
    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        }
      }
    });
}

const getOperators = () => {
  axios.get(backApi + '/public/operators/', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then((response) => {
      operatorsTemp = response.data.data ?? response.data;
    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        }
      }
    });
}

const changeStatus = (status, code) => {
  axios.put(`${backApi}/secure/fees/${code}/status`, {
    code: code,
    status: (status == 'ACTIVE') ? 'INACTIVE' : 'ACTIVE'
  }, {
    headers: {
      Authorization: `Bearer ${token}`,
    }
  }).then((response) => {
    router.go();
  }).catch((error) => {
    if (error.response) {
      if (error.response.status === 401) {
        router.push('/')
      }
    }
  });
}

const storeFee = () => {
  try {
    schema.validateSync(formValues);
    axios.post(`${backApi}/secure/fees/new`, {
      value: parseFloat(formValues.valeur),
      name: formValues.name,
      organization: selectedOrganization.value,
      country: selectedCountry.value,
      operator: selectedOperator.value,
      mode: selectedMode.value,
      typeFee: selectedTypeFee.value
    }, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    }).then((response) => {
      if (response.status === 200) {
        showToast("Frais de type " + selectedTypeFee.value.toLowerCase() + " enregistré avec succès", "green");
        initField();
      }
    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        } else {
          errorId.value = error.response.data.errorId;
          errors.value = error.response.data.message;
        }
      }
    });
  } catch (error) {
    errors.value = "une erreur inattendue est apparue"
  }
}

const storeFeeBulk = () => {
  errorIdBulk.value = '';
  errorsBulk.value = '';
  successBulk.value = '';

  try {
    const feesPayload = feeList.value.map(fee => ({
      typeFee: fee.name,
      value: Number(fee.valeur) || 0
    }));

    axios.post(`${backApi}/secure/fees/all`, {
      organization: selectedOrganization.value,
      fees: feesPayload
    }, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    }).then((response) => {
      if (response.status === 200) {
        showToast("Operation reussie", "green");
        feeList.value.forEach(fee => fee.valeur = 0);
      }
    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        } else {
          errorIdBulk.value = error.response.data.errorId;
          errorsBulk.value = error.response.data.message;
        }
        showToast(error.response.data.message, "red");
      }
    });
  } catch (error) {
    errorsBulk.value = "une erreur inattendue est apparue"
  }
}

function validate(field) {
  schema
    .validateAt(field, formValues)
    .then(() => {
      errorsBis[field] = "";
    })
    .catch(err => {
      errorsBis[field] = err.message;
    });
  errors.value = '';
}

onMounted(async () => {
  checkSessionValidate(1)
  const route = useRoute();
  code = route.params.id;
  selectedOrganization.value = code || '';
  getFees();
  getOperators();
  getOrganizations();
  getTypeFees();
  getCountries();

  setTimeout(function () {
    pageLoad.value = true;
  }, 1000)
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!pageLoad.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[11] || (_cache[11] = [
          _createElementVNode("div", {
            class: "spinner-grow text-danger",
            style: {"width":"3rem","height":"3rem","margin-top":"25vh","margin-left":"42%","margin-bottom":"5vh"},
            role: "status"
          }, [
            _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
          ], -1)
        ]))]))
      : _createCommentVNode("", true),
    (pageLoad.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(searchQuery) ? (searchQuery).value = $event : null)),
                type: "text",
                class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                placeholder: "Rechercher..."
              }, null, 512), [
                [_vModelText, _unref(searchQuery)]
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              (_unref(current_permissions)('create_fee'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0",
                    type: "button",
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#companyModal",
                    style: {"background-color":"#EB9355"},
                    onClick: initField
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.$t('fees.addFee')) + " ", 1),
                    _cache[12] || (_cache[12] = _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1))
                  ]))
                : _createCommentVNode("", true),
              (_unref(current_permissions)('create_all_fee'))
                ? (_openBlock(), _createElementBlock("button", _hoisted_6, [
                    _createTextVNode(_toDisplayString(_ctx.$t('fees.bulkFees')) + " ", 1),
                    _cache[13] || (_cache[13] = _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("table", _hoisted_9, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t('fees.code')), 1),
                    _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t('fees.organization')), 1),
                    _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t('fees.country')), 1),
                    _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.$t('fees.operator')), 1),
                    _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.$t('fees.name')), 1),
                    _createElementVNode("th", _hoisted_15, _toDisplayString(_ctx.$t('fees.value')), 1),
                    _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.$t('fees.mode')), 1),
                    _createElementVNode("th", _hoisted_17, _toDisplayString(_ctx.$t('fees.feeType')), 1),
                    _createElementVNode("th", _hoisted_18, _toDisplayString(_ctx.$t('fees.status')), 1),
                    _cache[14] || (_cache[14] = _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
                    }, null, -1))
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(paginatedFees), (fee) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: fee.id
                    }, [
                      _createElementVNode("td", _hoisted_19, _toDisplayString(fee.code), 1),
                      (fee.organization!==null)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_20, _toDisplayString(fee.organization.name), 1))
                        : _createCommentVNode("", true),
                      (fee.organization===null)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_21, _toDisplayString('')))
                        : _createCommentVNode("", true),
                      (fee.country!==null)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_22, _toDisplayString(fee.country.name), 1))
                        : _createCommentVNode("", true),
                      (fee.country===null)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_23, _toDisplayString('')))
                        : _createCommentVNode("", true),
                      (fee.operator!==null)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_24, _toDisplayString(fee.operator.mnoName), 1))
                        : _createCommentVNode("", true),
                      (fee.operator===null)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_25, _toDisplayString('')))
                        : _createCommentVNode("", true),
                      _createElementVNode("td", _hoisted_26, _toDisplayString(fee.name), 1),
                      _createElementVNode("td", _hoisted_27, _toDisplayString(fee.value), 1),
                      _createElementVNode("td", _hoisted_28, _toDisplayString(fee.mode), 1),
                      _createElementVNode("td", _hoisted_29, _toDisplayString(fee.typeFee.name), 1),
                      _createElementVNode("td", _hoisted_30, [
                        (fee.status==='ACTIVE')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(_ctx.$t('fees.active')), 1))
                          : _createCommentVNode("", true),
                        (fee.status==='INACTIVE')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(_ctx.$t('fees.inactive')), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", _hoisted_33, [
                        _createElementVNode("div", _hoisted_34, [
                          _cache[16] || (_cache[16] = _createElementVNode("button", {
                            class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                            type: "button",
                            "data-bs-toggle": "dropdown",
                            "aria-expanded": "false"
                          }, [
                            _createElementVNode("i", { class: "flaticon-dots" })
                          ], -1)),
                          _createElementVNode("ul", _hoisted_35, [
                            _createElementVNode("li", null, [
                              (_unref(current_permissions)('status_fee'))
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    class: "dropdown-item d-flex align-items-center",
                                    href: "javascript:void(0);",
                                    onClick: ($event: any) => (changeStatus(fee.status,fee.code))
                                  }, [
                                    _cache[15] || (_cache[15] = _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1)),
                                    (fee.status==='ACTIVE')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(_ctx.$t('fees.deactivate')), 1))
                                      : _createCommentVNode("", true),
                                    (fee.status==='INACTIVE')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(_ctx.$t('fees.activate')), 1))
                                      : _createCommentVNode("", true)
                                  ], 8, _hoisted_36))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]),
            (_unref(filteredTotal)>0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                  (_unref(filteredTotal)>10)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_40, [
                        _createTextVNode(_toDisplayString(_ctx.$t('fees.showing')) + " ", 1),
                        _createElementVNode("span", _hoisted_41, _toDisplayString(_unref(page)*10), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('fees.outOf')) + " ", 1),
                        _createElementVNode("span", _hoisted_42, _toDisplayString(_unref(filteredTotal)), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('fees.results')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(filteredTotal)<=10)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_43, [
                        _createTextVNode(_toDisplayString(_ctx.$t('fees.showing')) + " ", 1),
                        _createElementVNode("span", _hoisted_44, _toDisplayString(_unref(filteredTotal)), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('fees.outOf')) + " ", 1),
                        _createElementVNode("span", _hoisted_45, _toDisplayString(_unref(filteredTotal)), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('fees.results')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("nav", _hoisted_46, [
                    _createElementVNode("ul", _hoisted_47, [
                      ((_unref(page)-1)>0)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_48, [
                            _createElementVNode("a", {
                              class: "page-link",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(goToPage)(_unref(page)-1))),
                              "aria-label": "Previous"
                            }, [...(_cache[17] || (_cache[17] = [
                              _createElementVNode("i", { class: "flaticon-chevron-1" }, null, -1)
                            ]))])
                          ]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(numPages), (numPage) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: numPage,
                          class: "page-item"
                        }, [
                          (numPage==_unref(page))
                            ? (_openBlock(), _createElementBlock("a", _hoisted_49, _toDisplayString(numPage), 1))
                            : (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                class: "page-link",
                                onClick: ($event: any) => (_unref(goToPage)(numPage))
                              }, _toDisplayString(numPage), 9, _hoisted_50))
                        ]))
                      }), 128)),
                      ((_unref(page)+1)<=_unref(numPages))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_51, [
                            _createElementVNode("a", {
                              class: "page-link",
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(goToPage)(_unref(page)+1))),
                              "aria-label": "Next"
                            }, [...(_cache[18] || (_cache[18] = [
                              _createElementVNode("i", { class: "flaticon-chevron" }, null, -1)
                            ]))])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_52, [
      _createElementVNode("div", _hoisted_53, [
        _createElementVNode("div", _hoisted_54, [
          _createElementVNode("form", {
            onSubmit: _withModifiers(storeFeeBulk, ["prevent"])
          }, [
            _createElementVNode("div", _hoisted_55, [
              _createElementVNode("h1", _hoisted_56, _toDisplayString(_ctx.$t('fees.bulkFees')), 1),
              _cache[19] || (_cache[19] = _createElementVNode("button", {
                type: "button",
                class: "btn-close",
                "data-bs-dismiss": "modal",
                "aria-label": "Close"
              }, null, -1))
            ]),
            _createElementVNode("div", _hoisted_57, [
              (errorsBulk.value!=='')
                ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                    _createElementVNode("h6", _hoisted_59, _toDisplayString(errorIdBulk.value), 1),
                    _createElementVNode("h6", _hoisted_60, _toDisplayString(errorsBulk.value), 1)
                  ]))
                : _createCommentVNode("", true),
              (successBulk.value!=='')
                ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                    _createElementVNode("h6", _hoisted_62, _toDisplayString(successBulk.value), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_63, [
                _createElementVNode("div", _hoisted_64, [
                  _createElementVNode("label", _hoisted_65, _toDisplayString(_ctx.$t('fees.organization')), 1),
                  _withDirectives(_createElementVNode("select", {
                    name: "organization",
                    id: "organization",
                    class: "form-select fs-md-15 text-black shadow-none",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedOrganization).value = $event)),
                    required: ""
                  }, [
                    _createElementVNode("option", _hoisted_66, _toDisplayString(_ctx.$t('fees.select')), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(organizations.value, (organization) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: organization.code,
                        key: organization.code
                      }, _toDisplayString(organization.name), 9, _hoisted_67))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, selectedOrganization.value]
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(feeList.value, (fee, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "row mb-3"
                  }, [
                    _createElementVNode("div", _hoisted_68, [
                      _createElementVNode("label", _hoisted_69, _toDisplayString(_ctx.$t('fees.feeType')), 1),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": ($event: any) => ((fee.name) = $event),
                        type: "text",
                        class: "form-control",
                        disabled: ""
                      }, null, 8, _hoisted_70), [
                        [_vModelText, fee.name]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_71, [
                      _createElementVNode("label", _hoisted_72, _toDisplayString(_ctx.$t('fees.value')), 1),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": ($event: any) => ((fee.valeur) = $event),
                        type: "number",
                        class: _normalizeClass(["form-control", { 'is-invalid': errorsBis[index]?.valeur }])
                      }, null, 10, _hoisted_73), [
                        [
                          _vModelText,
                          fee.valeur,
                          void 0,
                          { number: true }
                        ]
                      ]),
                      _createElementVNode("span", _hoisted_74, _toDisplayString(errorsBis[index]?.valeur), 1)
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_75, [
              (_unref(current_permissions)('create_all_fee'))
                ? (_openBlock(), _createElementBlock("button", _hoisted_76, [
                    _cache[20] || (_cache[20] = _createElementVNode("i", {
                      class: "flaticon-plus position-relative ms-5 fs-12",
                      style: {"color":"#FFF"}
                    }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('fees.save')), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 32)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_77, [
      _createElementVNode("div", _hoisted_78, [
        _createElementVNode("div", _hoisted_79, [
          _createElementVNode("form", {
            onSubmit: _withModifiers(storeFee, ["prevent"])
          }, [
            _createElementVNode("div", _hoisted_80, [
              _createElementVNode("h1", _hoisted_81, _toDisplayString(_ctx.$t('fees.fee')), 1),
              _cache[21] || (_cache[21] = _createElementVNode("button", {
                type: "button",
                class: "btn-close",
                "data-bs-dismiss": "modal",
                "aria-label": "Close"
              }, null, -1))
            ]),
            _createElementVNode("div", _hoisted_82, [
              (errors.value!=='')
                ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                    _createElementVNode("h6", _hoisted_84, _toDisplayString(errorId.value), 1),
                    _createElementVNode("h6", _hoisted_85, _toDisplayString(errors.value), 1)
                  ]))
                : _createCommentVNode("", true),
              (success.value!=='')
                ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                    _createElementVNode("h6", _hoisted_87, _toDisplayString(success.value), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_88, [
                _createElementVNode("div", _hoisted_89, [
                  _createElementVNode("div", _hoisted_90, [
                    _createElementVNode("label", _hoisted_91, _toDisplayString(_ctx.$t('fees.name')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formValues.name) = $event)),
                        type: "text",
                        class: _normalizeClass(["form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16", { 'is-invalid': errorsBis['name'] }]),
                        id: "lead-calendar",
                        placeholder: _ctx.$t('fees.namePlaceholder'),
                        onBlur: _cache[5] || (_cache[5] = ($event: any) => (validate('name'))),
                        onKeyup: _cache[6] || (_cache[6] = ($event: any) => (validate('name')))
                      }, null, 42, _hoisted_92), [
                        [_vModelText, formValues.name]
                      ]),
                      _createElementVNode("span", _hoisted_93, _toDisplayString(errorsBis['name']), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_94, [
                    _createElementVNode("label", _hoisted_95, _toDisplayString(_ctx.$t('fees.value')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formValues.valeur) = $event)),
                        type: "text",
                        class: _normalizeClass(["form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16", { 'is-invalid': errorsBis['valeur'] }]),
                        id: "lead-calendar",
                        placeholder: _ctx.$t('fees.valuePlaceholder'),
                        onBlur: _cache[8] || (_cache[8] = ($event: any) => (validate('valeur'))),
                        onKeyup: _cache[9] || (_cache[9] = ($event: any) => (validate('valeur')))
                      }, null, 42, _hoisted_96), [
                        [_vModelText, formValues.valeur]
                      ]),
                      _createElementVNode("span", _hoisted_97, _toDisplayString(errorsBis['valeur']), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_98, [
                  _createElementVNode("div", _hoisted_99, [
                    _createElementVNode("label", _hoisted_100, _toDisplayString(_ctx.$t('fees.mode')), 1),
                    _createElementVNode("select", {
                      name: "mode",
                      id: "mode",
                      class: "form-select fs-md-15 text-black shadow-none",
                      onChange: handleModeChange,
                      required: ""
                    }, [
                      _createElementVNode("option", {
                        value: "",
                        selected: selectedMode.value==''
                      }, _toDisplayString(_ctx.$t('fees.select')), 9, _hoisted_101),
                      _createElementVNode("option", {
                        value: "PERCENT",
                        selected: selectedMode.value=='PERCENT'
                      }, _toDisplayString(_ctx.$t('fees.percent')), 9, _hoisted_102),
                      _createElementVNode("option", {
                        value: "VALUE",
                        selected: selectedMode.value=='VALUE'
                      }, _toDisplayString(_ctx.$t('fees.valueType')), 9, _hoisted_103)
                    ], 32)
                  ]),
                  _createElementVNode("div", _hoisted_104, [
                    _createElementVNode("label", _hoisted_105, _toDisplayString(_ctx.$t('fees.feeType')), 1),
                    _createElementVNode("select", {
                      name: "typefee",
                      id: "typefee",
                      class: "form-select fs-md-15 text-black shadow-none",
                      onChange: handleTypeFeeChange,
                      required: ""
                    }, [
                      _createElementVNode("option", {
                        value: "",
                        selected: selectedTypeFee.value==''
                      }, _toDisplayString(_ctx.$t('fees.select')), 9, _hoisted_106),
                      _createElementVNode("option", {
                        value: "COLLECT",
                        selected: selectedTypeFee.value=='COLLECT'
                      }, _toDisplayString(_ctx.$t('fees.operatorCollectFee')), 9, _hoisted_107),
                      _createElementVNode("option", {
                        value: "I-MONEY",
                        selected: selectedTypeFee.value=='I-MONEY'
                      }, _toDisplayString(_ctx.$t('fees.iMoneyCollectFee')), 9, _hoisted_108),
                      _createElementVNode("option", {
                        value: "PAYOUT",
                        selected: selectedTypeFee.value=='PAYOUT'
                      }, _toDisplayString(_ctx.$t('fees.operatorPayoutFee')), 9, _hoisted_109),
                      _createElementVNode("option", {
                        value: "I-MONEY PAYOUT",
                        selected: selectedTypeFee.value=='I-MONEY PAYOUT'
                      }, _toDisplayString(_ctx.$t('fees.iMoneyPayoutFee')), 9, _hoisted_110),
                      _createElementVNode("option", {
                        value: "BANK_REPAYMENT",
                        selected: selectedTypeFee.value=='BANK_REPAYMENT'
                      }, _toDisplayString(_ctx.$t('fees.bankRepayment')), 9, _hoisted_111),
                      _createElementVNode("option", {
                        value: "CRYPTO_REPAYMENT",
                        selected: selectedTypeFee.value=='CRYPTO_REPAYMENT'
                      }, _toDisplayString(_ctx.$t('fees.cryptoRepayment')), 9, _hoisted_112),
                      _createElementVNode("option", {
                        value: "TOPUP",
                        selected: selectedTypeFee.value=='TOPUP'
                      }, _toDisplayString(_ctx.$t('fees.topup')), 9, _hoisted_113)
                    ], 32)
                  ])
                ]),
                _createElementVNode("div", _hoisted_114, [
                  (selectedTypeFee.value!=='COLLECT' && selectedTypeFee.value!=='PAYOUT')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_115, [
                        _createElementVNode("label", _hoisted_116, _toDisplayString(_ctx.$t('fees.organization')), 1),
                        _withDirectives(_createElementVNode("select", {
                          name: "organization",
                          id: "organization",
                          class: "form-select fs-md-15 text-black shadow-none",
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((selectedOrganization).value = $event)),
                          required: ""
                        }, [
                          _createElementVNode("option", _hoisted_117, _toDisplayString(_ctx.$t('fees.select')), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(organizations.value, (organization) => {
                            return (_openBlock(), _createElementBlock("option", {
                              value: organization.code,
                              key: organization.code
                            }, _toDisplayString(organization.name), 9, _hoisted_118))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, selectedOrganization.value]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_119, [
                    _createElementVNode("label", _hoisted_120, _toDisplayString(_ctx.$t('fees.country')), 1),
                    _createElementVNode("select", {
                      name: "country",
                      id: "country",
                      class: "form-select fs-md-15 text-black shadow-none",
                      onChange: handleCountryChange,
                      required: ""
                    }, [
                      _createElementVNode("option", _hoisted_121, _toDisplayString(_ctx.$t('fees.select')), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(countries.value, (country) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: country.countryCode,
                          key: country.code,
                          selected: selectedCountry.value==country.countryCode
                        }, _toDisplayString(country.name), 9, _hoisted_122))
                      }), 128))
                    ], 32)
                  ])
                ]),
                (selectedTypeFee.value=='COLLECT' || selectedTypeFee.value=='PAYOUT')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_123, [
                      _createElementVNode("div", _hoisted_124, [
                        _createElementVNode("label", _hoisted_125, _toDisplayString(_ctx.$t('fees.operators')), 1),
                        _createElementVNode("select", {
                          name: "operator",
                          id: "operator",
                          class: "form-select fs-md-15 text-black shadow-none",
                          onChange: handleOperatorChange,
                          required: ""
                        }, [
                          _createElementVNode("option", _hoisted_126, _toDisplayString(_ctx.$t('fees.select')), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(operators.value, (operator) => {
                            return (_openBlock(), _createElementBlock("option", {
                              value: operator.code,
                              key: operator.code,
                              selected: selectedOperator.value==operator.code
                            }, _toDisplayString(operator.mnoName), 9, _hoisted_127))
                          }), 128))
                        ], 32)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_128, [
              (_unref(current_permissions)('create_fee'))
                ? (_openBlock(), _createElementBlock("button", _hoisted_129, [
                    _cache[22] || (_cache[22] = _createElementVNode("i", {
                      class: "flaticon-plus position-relative ms-5 fs-12",
                      style: {"color":"#FFF"}
                    }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('fees.save')), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 32)
        ])
      ])
    ]),
    _cache[23] || (_cache[23] = _createElementVNode("div", { id: "snackbar" }, null, -1))
  ], 64))
}
}

})